document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.animation-group-root').forEach((root) => {
    root.querySelectorAll('.custom-svg-container svg').forEach((svg) => {
      // Skip AJAX-injected hosts — custom.js owns those after fetch
      if (svg.closest('.dynamic-svg')) return;

      svg.setAttribute('preserveAspectRatio', 'none');
      const shapes = svg.querySelectorAll(
        'path, line, polyline, polygon, rect, circle, ellipse'
      );

      const slide = root.closest('slideshow-slide');
      if (slide) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'aria-hidden') {
              const isHidden = slide.getAttribute('aria-hidden') === 'true';
              if (!isHidden) {
                startAnimation(shapes, svg);
              } else {
                resetAnimation(shapes, svg);
              }
            }
          });
        });
        observer.observe(slide, { attributes: true });

        if (slide.getAttribute('aria-hidden') !== 'true') {
          startAnimation(shapes, svg);
        } else {
          resetAnimation(shapes, svg);
        }
      } else {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                startAnimation(shapes, svg);
                observer.disconnect();
              }
            });
          },
          { threshold: 0.1 }
        );
        observer.observe(root);
      }
    });
  });
});

function clearFloatTimer(svg) {
  if (!svg) return;
  const timerId = svg._waveFloatTimer;
  if (timerId) {
    clearTimeout(timerId);
    svg._waveFloatTimer = null;
  }
}

function resetAnimation(shapes, svgEl) {
  const shapesArray = Array.from(shapes);
  const svg = svgEl || (shapesArray[0] && shapesArray[0].ownerSVGElement);

  clearFloatTimer(svg);

  shapesArray.forEach((el) => {
    el.style.animation = 'none';
    el.style.removeProperty('stroke-dasharray');
    el.style.removeProperty('stroke-dashoffset');
    el.style.opacity = '';
    el.style.transform = '';
    el.removeAttribute('data-wave-ready');
  });

  if (svg) {
    svg.removeAttribute('data-wave-started');
    svg.removeAttribute('data-wave-float-ready');
    const container = svg.closest('.custom-svg-container');
    if (container) container.classList.remove('is-floating');
  }
}

/**
 * Two-phase animation (no overlap = less blinking):
 * 1) Wave draw only
 * 2) After ALL draws finish → start smooth float motion
 */
function startAnimation(shapes, svgEl) {
  const shapesArray = Array.from(shapes);
  if (!shapesArray.length) return;

  const svg = svgEl || shapesArray[0].ownerSVGElement;
  if (!svg || svg.getAttribute('data-wave-started') === 'true') return;

  const container = svg.closest('.custom-svg-container');
  if (container && window.getComputedStyle(container).display === 'none') {
    return;
  }

  clearFloatTimer(svg);
  if (container) container.classList.remove('is-floating');

  svg.setAttribute('data-wave-started', 'true');

  const strokeShapes = [];
  const fillOnlyShapes = [];

  shapesArray.forEach((el) => {
    const stroke = el.getAttribute('stroke');
    const fill = el.getAttribute('fill');
    const hasStroke = stroke && stroke !== 'none';
    const hasFill = fill && fill !== 'none';

    if (!hasStroke && hasFill) {
      fillOnlyShapes.push(el);
    } else {
      strokeShapes.push(el);
    }
  });

  fillOnlyShapes.forEach((el) => {
    el.style.animation = 'none';
    el.setAttribute('data-wave-ready', 'true');
    el.style.opacity = '1';
  });

  const totalShapes = strokeShapes.length;
  const staggerInterval =
    totalShapes > 80 ? 0.012 : totalShapes > 40 ? 0.025 : 0.05;
  const maxDelay = 2.2;
  const drawDuration = 1.5;
  const floatDuration = 7;

  // Pass 1 — prepare dashes
  strokeShapes.forEach((el) => {
    if (!el.getAttribute('stroke')) {
      el.setAttribute('stroke', 'currentColor');
    }
    if (!el.getAttribute('stroke-width')) {
      el.setAttribute('stroke-width', '1');
    }
    if (!el.getAttribute('fill')) {
      el.setAttribute('fill', 'none');
    }

    el.setAttribute('pathLength', '1');
    el.style.animation = 'none';
    el.style.removeProperty('transform');
    el.style.transformBox = 'fill-box';
    el.style.transformOrigin = 'center';
    el.style.strokeDasharray = '1';
    el.style.strokeDashoffset = '1';
    el.setAttribute('data-wave-ready', 'true');
    el.style.opacity = '1';
  });

  void svg.getBoundingClientRect();

  // Phase 1 — WAVE DRAW ONLY (no float yet)
  strokeShapes.forEach((el, index) => {
    const delay = Math.min(index * staggerInterval, maxDelay);
    el.style.animation =
      'drawPath ' + drawDuration + 's ease-out ' + delay + 's forwards';
  });

  // Phase 2 — after the last path finishes drawing, start float
  const waveCompleteMs = Math.ceil((maxDelay + drawDuration) * 1000) + 50;

  svg._waveFloatTimer = setTimeout(function () {
    svg._waveFloatTimer = null;
    if (!svg.isConnected) return;

    // Lock drawn state, clear draw animation, then float only
    strokeShapes.forEach((el) => {
      el.style.strokeDashoffset = '0';
      el.style.animation = 'none';
    });

    void svg.getBoundingClientRect();

    strokeShapes.forEach((el, index) => {
      // Force individual reflow to ensure iOS/Safari triggers the new animation
      void el.offsetWidth;
      // Use a larger negative delay so the paths are spread across multiple animation cycles.
      // This ensures they ripple individually in a wave rather than looking like the whole SVG is moving together.
      const delay = -(index * 0.15);
      el.style.animation =
        'floatAnimation ' + floatDuration + 's ease-in-out ' + delay + 's infinite';
    });

    svg.setAttribute('data-wave-float-ready', 'true');
  }, waveCompleteMs);
}
